import { helpers } from '../helpers.js';

var cache = {
	init: function () {
		const self = this;

		self.emptyCache();
	},

	emptyCache: function() {
		const self = this;

		if( ! jQuery( '.js-clearCache' ) ) {
			return false;
		}

		jQuery( '.js-clearCache' ).on( 'click', function( e ){
			e.preventDefault();

			helpers.pctApiCall({
				action: 'request_recache',
				url: window.location.href,
				maybe_object: jQuery( this ).attr( 'data-type' ),
			}).then( response => {
				if( ! response.success ) {
					// return false; // alert??
				}
	
				alert( response.data.message );
			}).catch(error => {
				console.error( 'Cache not working ' , error); 
			});
		});
	}
};

export { cache };